import type { Translations } from '@/types';

export const es: Translations = {
  'app.title': 'Simulador de Página Bloqueada Firewall',
  'app.subtitle': 'Plataforma de Capacitación y Educación',
  'app.disclaimer': 'Esta es una página de bloqueo firewall simulada solo para fines de capacitación. No ha ocurrido ninguna violación real de política de seguridad.',
  
  'nav.generator': 'Generador',
  'nav.dashboard': 'Analíticas',
  'nav.settings': 'Configuración',
  'nav.help': 'Ayuda',
  
  'config.basicInfo': 'Información Básica',
  'config.blockedUrl': 'URL Bloqueada',
  'config.category': 'Categoría',
  'config.firewallMode': 'Modo Firewall',
  'config.organization': 'Nombre de la Organización',
  
  'config.networkDetails': 'Detalles de Red',
  'config.firewallName': 'Nombre del Firewall',
  'config.ipAddress': 'Dirección IP del Cliente',
  'config.userName': 'Nombre de Usuario (Opcional)',
  
  'config.errorInfo': 'Información de Error',
  'config.errorCode': 'Código de Error',
  'config.blockType': 'Tipo de Bloqueo',
  
  'config.adminContact': 'Contacto del Administrador',
  'config.adminEmail': 'Email del Admin',
  'config.adminPhone': 'Teléfono del Admin',
  'config.adminPortal': 'URL del Portal Admin',
  
  'config.technicalDetails': 'Detalles Técnicos',
  'config.policyId': 'ID de Política',
  'config.firewallSerial': 'Número de Serie Firewall',
  'config.threatId': 'ID de Amenaza',
  'config.webFilterProfile': 'Perfil de Filtro Web',
  'config.securityProfile': 'Perfil de Seguridad',
  'config.sslInspection': 'Inspección SSL',
  'config.actionTaken': 'Acción Tomada',
  'config.destinationIp': 'IP de Destino',
  'config.destinationPort': 'Puerto de Destino',
  'config.protocol': 'Protocolo',
  'config.sessionId': 'ID de Sesión',
  
  'config.displayOptions': 'Opciones de Visualización',
  'config.showDisclaimer': 'Mostrar Aviso de Capacitación',
  'config.showTechnicalDetails': 'Mostrar Detalles Técnicos',
  'config.showRequestAccess': 'Mostrar Botón Solicitar Acceso',
  'config.theme': 'Tema',
  'config.language': 'Idioma',
  
  'scenarios.title': 'Preajustes de Escenarios',
  'scenarios.malware': 'Sitio de Distribución de Malware',
  'scenarios.phishing': 'Intento de Phishing',
  'scenarios.adultContent': 'Bloqueo de Contenido Adulto',
  'scenarios.gaming': 'Bloqueo de Sitio de Juegos',
  'scenarios.geoBlock': 'Región Geo-Bloqueada',
  'scenarios.socialMedia': 'Bloqueo de Redes Sociales',
  'scenarios.streaming': 'Bloqueo de Streaming',
  
  'export.title': 'Opciones de Exportación',
  'export.html': 'Exportar como HTML',
  'export.zip': 'Descargar Paquete ZIP',
  'export.json': 'Exportar Config (JSON)',
  'export.copy': 'Copiar HTML al Portapapeles',
  'export.screenshot': 'Generar Captura de Pantalla',
  
  'preview.title': 'Vista Previa',
  'preview.live': 'Vista Previa en Vivo',
  
  'requestAccess.title': 'Solicitar Acceso',
  'requestAccess.name': 'Su Nombre',
  'requestAccess.email': 'Su Email',
  'requestAccess.reason': 'Razón del Acceso',
  'requestAccess.submit': 'Enviar Solicitud',
  'requestAccess.success': '¡Solicitud enviada con éxito!',
  'requestAccess.ticketId': 'Su número de ticket:',
  
  'training.title': 'Modo de Capacitación',
  'training.enable': 'Activar Modo de Capacitación',
  'training.tooltip.webFilter': 'El filtrado web bloquea el acceso a sitios web según su categoría de contenido. Esto ayuda a las organizaciones a hacer cumplir las políticas de uso aceptable.',
  'training.tooltip.category': 'Las categorías de contenido clasifican los sitios web por su propósito principal. Las categorías como Malware, Phishing y Contenido Adulto se bloquean comúnmente en entornos corporativos.',
  'training.tooltip.sslInspection': 'La inspección SSL descifra y analiza el tráfico HTTPS encriptado para detectar amenazas que pueden estar ocultas en conexiones seguras.',
  'training.tooltip.policy': 'Las políticas de seguridad definen qué tráfico está permitido o bloqueado según varios criterios incluyendo usuario, grupo, hora y categoría de contenido.',
  
  'dashboard.title': 'Panel de Analíticas',
  'dashboard.totalBlocks': 'Total de Intentos Bloqueados',
  'dashboard.topCategories': 'Principales Categorías Bloqueadas',
  'dashboard.timeline': 'Línea de Tiempo de Bloqueos',
  
  'common.save': 'Guardar',
  'common.load': 'Cargar',
  'common.reset': 'Restablecer',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.generate': 'Generar',
  'common.export': 'Exportar',
  'common.copy': 'Copiar',
  'common.copied': '¡Copiado!',
  'common.error': 'Error',
  'common.success': 'Éxito',
};
